import type { ReactNode } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../form';
import { PasswordInput } from '../password-input';
import { Text } from '@folio/components/ui/text';

export type FormPasswordInputProps<TFields extends FieldValues> = {
  control: Control<TFields>;
  label?: ReactNode;
  type?: string;
  name: Path<TFields>;
  placeholder?: string;
  description?: ReactNode;
  required?: boolean;
  autoComplete?: string;
  disabled?: boolean;
};

export const FormPasswordInput = <TFields extends FieldValues>({
  control,
  label,
  name,
  placeholder,
  description,
  required,
  autoComplete,
  disabled,
}: FormPasswordInputProps<TFields>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {!!label && (
            <FormLabel>
              {label}{' '}
              {required && (
                <Text inline tone="destructive">
                  *
                </Text>
              )}
            </FormLabel>
          )}
          <FormControl>
            <PasswordInput
              placeholder={placeholder}
              autoComplete={autoComplete}
              disabled={disabled}
              {...field}
            />
          </FormControl>
          {!!description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
